/* eslint-disable import/no-named-as-default-member */
import dayjs from 'dayjs';
import BigIntSupport from 'dayjs/plugin/bigIntSupport';
import RelativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(BigIntSupport);
dayjs.extend(RelativeTime);

export default dayjs;
